<template>
  <nav style="width: 206px">
    <ul class="items-center text-base">
      <li class="mb-5">
        <router-link
          :to="{
            name: 'TxSelectSummary',
            params: { selectId: transactionServiceSelectId },
          }"
          class="leading-8 pl-6 mb-6 box-border border-l-2 py-1 border-gray-12 font-semibold"
          :class="{
            'text-gray-92': $route.name === 'TxSelectSummary',
            'border-secondary-main': $route.name === 'TxSelectSummary',
          }"
        >
          依頼概要
        </router-link>
        <ul
          v-if="$route.name === 'TxSelectSummary'"
          class="mt-6 ml-10 text-sm leading-4"
        >
          <li class="mb-4" v-if="conciergeComment">
            <div
              class="cursor-pointer text-gray-62"
              v-scroll-to="{ el: '#concierge-comment', offset: -110 }"
            >
              PRONIコンシェルジュ<br />
              からのひとことメモ
            </div>
          </li>
          <li class="mb-4">
            <div
              class="cursor-pointer text-gray-62"
              v-scroll-to="{ el: '#selection-content', offset: -300 }"
            >
              募集内容
            </div>
          </li>
          <li v-if="adminSupplements && adminSupplements.length > 0">
            <div
              class="cursor-pointer text-gray-62"
              v-scroll-to="{ el: '#admin-supplements' }"
            >
              PRONIメンバーズ<br />
              事務局コメント
            </div>
          </li>
        </ul>
      </li>
      <li class="mb-5" v-if="state.isSelectAnswered && !state.isApplied">
        <router-link
          :to="{
            name: 'TxSelectResponse',
            params: { selectId: transactionServiceSelectId },
          }"
          class="leading-8 pl-6 mb-6 box-border border-l-2 py-1 border-gray-12 font-semibold"
          :class="{
            'text-gray-92': $route.name === 'TxSelectResponse',
            'border-secondary-main': $route.name === 'TxSelectResponse',
          }"
        >
          募集回答
        </router-link>
      </li>
      <li class="mb-5" v-if="state.isApplied && transaction.answered_at">
        <router-link
          :to="{
            name: 'TxSelectApplication',
            params: { selectId: transactionServiceSelectId },
          }"
          class="leading-8 pl-6 mb-6 box-border border-l-2 py-1 border-gray-12 font-semibold"
          :class="{
            'text-gray-92': $route.name === 'TxSelectApplication',
            'border-secondary-main': $route.name === 'TxSelectApplication',
          }"
        >
          応募内容
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import { reactive, onBeforeMount } from 'vue';
import axios from '@/utils/axiosAuth';

export default {
  props: {
    transaction: Object,
    transactionServiceSelectId: String,
    conciergeComment: Object,
    adminSupplements: Array,
  },
  setup(props) {
    const state = reactive({
      isSelectAnswered: false,
      isApplied: false,
    });

    onBeforeMount(async () => {
      axios
        .get(
          `/transaction-selects/${props.transactionServiceSelectId}/response`
        )
        .then((response) => {
          const data = response?.data?.data;
          if (data?.is_answered || data?.is_refused) {
            state.isSelectAnswered = true;
          }
        })
        .catch(() => {
          // 直接指名のときに404になる
          // 募集の回答データが取得できなければ表示しない
        });

      // 募集の応募データが取得できれば募集済みとして判断
      axios
        .get(
          `/transaction-selects/${props.transactionServiceSelectId}/application`
        )
        .then(() => {
          state.isApplied = true;
        })
        .catch(() => {});
    });

    return {
      state,
    };
  },
};
</script>
